/* AtomOffice add-on for the Be Yours 9.5.1 scroll tracker (assets/content-scrollspy.js, unmodified).
   Loaded after it (defer, from ao-body-end) on product pages and article.guide. Adapted from the
   2026-10-05 preview (feature-preview/product-scrollspy). Patches the stock class's prototype:
   1. detectHeadings: chapters in the order they appear ON SCREEN (our renderer reorders blocks with
      CSS order, so "What's in the Box" sits last in the markup but after Gallery on screen) and only
      headings that are actually displayed.
   2. calculateScrollOffsets: a tapped chapter lands below our sticky header (.shopify-section-header;
      the stock lookup only finds a sticky <header>) plus the tracker bar (--ao-bar-h).
   3. getTopMostVisibleSectionIndex: current chapter = last heading above a reading line 25% down,
      not the next heading appearing at the bottom of the screen.
   4. updateFixedMenu: show the tracker as the first chapter slides under the header.
   Plus short labels, position numbers and the phone dock open/close. */
(function () {
  var Spy = window.ContentScrollSpy;
  if (!Spy || Spy.__ao) return;
  Spy.__ao = true;
  var HIDDEN = 'content-scrollspy__menu--hidden';
  var SHORT = [[/^Detailed Specifications$/i, 'Specs'], [/^Frequently Asked Questions$/i, 'FAQ'],
    [/^Official (&|and) Recommended Options$/i, 'Options'], [/^Learn More About\b/i, 'Learn more']];
  function headerBottom() { var h = document.querySelector('.shopify-section-header'); return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0; }
  function barH(spy) { return parseFloat(getComputedStyle(spy).getPropertyValue('--ao-bar-h')) || 0; }
  function line(spy) { var hb = headerBottom(); return hb + barH(spy) + (window.innerHeight - hb) * 0.25; }
  var P = Spy.prototype;

  P.detectHeadings = function () {
    var s = this.settings;
    if (!s.headingSelector) return;
    var sel = s.headingSelector.split(',').map(function (x) { return x.trim(); }).filter(Boolean).join(', ');
    if (!sel) return;
    var scope = this.getScopeElement(s.contentScope);
    var seen = [], hs = [];
    scope.querySelectorAll(sel).forEach(function (h) {
      if (seen.indexOf(h) < 0 && (h.textContent || '').trim() && h.getClientRects().length) { seen.push(h); hs.push(h); }
    });
    if (!hs.length) return;
    hs.sort(function (a, b) {
      var d = a.getBoundingClientRect().top - b.getBoundingClientRect().top;
      return d || (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
    });
    this.generateMenuItems(hs);
    this.ensureHeadingIds(hs);
    this.setupScrollHandling();
  };
  P.calculateScrollOffsets = function () { var b = barH(this), h = headerBottom(); return { menu: b, additional: h, total: h + b }; };
  P.getTopMostVisibleSectionIndex = function () {
    var l = line(this), idx = null;
    for (var i = 0; i < this.sections.length; i++) if (this.sections[i].getBoundingClientRect().top <= l) idx = i;
    return idx;
  };
  P.updateFixedMenu = function () {
    if (!this.menu) this.menu = this.querySelector('[data-scrollspy-menu]');
    if (!this.menu || !this.firstSection) return;
    this.menu.classList.toggle(HIDDEN, this.firstSection.getBoundingClientRect().top > headerBottom() + barH(this) + 8);
  };

  function items(spy) { return spy.menu ? Array.prototype.slice.call(spy.menu.querySelectorAll('.content-scrollspy__menu-item')) : []; }
  function prepare(spy) {
    if (!spy) return;
    var list = items(spy);
    if (!list.length || list[0].hasAttribute('data-pos')) return;
    spy.classList.add('ao-spy-js');
    list.forEach(function (a, i) {
      var full = a.textContent.trim();
      a.title = full; a.setAttribute('aria-label', full);
      for (var k = 0; k < SHORT.length; k++) if (SHORT[k][0].test(full)) { a.textContent = SHORT[k][1]; break; }
      a.setAttribute('data-pos', (i + 1) + ' / ' + list.length);
    });
    if (!spy.menu.__aoDock) { spy.menu.__aoDock = true; spy.menu.addEventListener('click', dockClick, true); }
  }
  /* Phone dock (--ao-dock: 1): first tap opens the chapter list, a tap on a chapter jumps and closes. */
  function dockClick(e) {
    var nav = e.currentTarget;
    if (getComputedStyle(nav).getPropertyValue('--ao-dock').trim() !== '1') return;
    if (!nav.classList.contains('is-open')) { e.preventDefault(); e.stopPropagation(); nav.classList.add('is-open'); }
    else nav.classList.remove('is-open');
  }
  /* The stock class dispatches its events on document, with itself in detail.scrollspy. */
  document.addEventListener('scrollspy:ready', function (e) { prepare(e.detail && e.detail.scrollspy); });
  document.addEventListener('scrollspy:section-changed', function () {
    document.querySelectorAll('.content-scrollspy__menu.is-open').forEach(function (n) { n.classList.remove('is-open'); });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.content-scrollspy__menu.is-open').forEach(function (n) { if (!n.contains(e.target)) n.classList.remove('is-open'); });
  });
  /* If the tracker finished before this file ran, rebuild it with the patched methods. */
  document.querySelectorAll('content-scrollspy').forEach(function (s) { if (s.isInitialized) s.refresh(); });
})();
